import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-tooltip',
  template: `
    <div [ngClass]="{'left_and_right_placement' : (placement === 'left') || (placement === 'right')}">
      <div class="bottom_indicator" *ngIf="placement === 'bottom'"
           [ngClass]="{'dark_theme_bottom_indicator' : theme === 'dark' && placement === 'bottom' ,
            'light_theme_bottom_indicator' : theme === 'light' && placement === 'bottom'}"></div>
      <div class="left_indicator"
           *ngIf="placement === 'right'"
           [ngClass]="{'dark_theme_right_indicator' : theme === 'dark' && placement === 'right' ,
            'light_theme_right_indicator' : theme === 'light' && placement === 'right'}"></div>
      <div class="right_indicator flex_order"
           *ngIf="placement === 'left'"
           [ngClass]="{'dark_theme_left_indicator' : theme === 'dark' && placement === 'left' ,
            'light_theme_left_indicator' : theme === 'light' && placement === 'left'}"></div>
      <div class="la_tooltip__background"
           [ngClass]="{'dark_theme_background' : theme === 'dark' , 'light_theme_background' : theme === 'light'}">
        <la-text [kind]="'title-2'">
          <p [ngClass]="{'dark_theme_color' : theme === 'dark' ,
                    'light_theme_color' : theme === 'light'}">
            <ng-content></ng-content>
          </p>
        </la-text>
      </div>
      <div class="top_indicator" *ngIf="placement === 'top'"
           [ngClass]="{'dark_theme_top_indicator' : theme === 'dark' && placement === 'top' ,
       'light_theme_top_indicator' : theme === 'light' && placement === 'top'}"></div>
    </div>`,
  styles: [`
    .la_tooltip__background{width:166px;height:75.3px;box-shadow:1px 2px 14px 0 rgba(3,20,34,.08);padding:10px 15px;border-radius:10px}.dark_theme_background{background-color:#031422}.light_theme_background{background-color:#fff}.dark_theme_color{color:#fff}.light_theme_color{color:#031422}.dark_theme_top_indicator{border-top:25px solid #031422}.light_theme_top_indicator{border-top:25px solid #fff}.top_indicator{width:0;height:0;margin:-8px auto 0;border-left:25px solid transparent;border-right:25px solid transparent}.dark_theme_bottom_indicator{border-bottom:25px solid #031422}.light_theme_bottom_indicator{border-bottom:25px solid #fff}.bottom_indicator{width:0;height:0;margin:0 auto -10px;border-left:25px solid transparent;border-right:25px solid transparent}.left_indicator{width:0;height:0;margin:0 -8px 0 0;border-top:25px solid transparent;border-bottom:25px solid transparent}.dark_theme_left_indicator{border-left:25px solid #031422}.light_theme_left_indicator{border-left:25px solid #fff}.right_indicator{width:0;height:0;margin:0 0 0 -8px;border-top:25px solid transparent;border-bottom:25px solid transparent}.dark_theme_right_indicator{border-right:25px solid #031422}.light_theme_right_indicator{border-right:25px solid #fff}.left_and_right_placement{display:flex;align-items:center}.flex_order{order:2}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaTooltipComponent {
  private _theme = 'dark'; // dark light
  private _placement = ''; // top left right bottom
  get theme(): string {
    return this._theme;
  }

  /**
   * Theme of the tooltip is dark , light and depends upon the user
   */
  @Input()
  set theme(style: string) {
    this._theme = style;
  }

  get placement(): string {
    return this._placement;
  }

  /**
   * placement is top bottom left right depends upon the user
   */
  @Input()
  set placement(style: string) {
    this._placement = style;
  }
}
